module.exports = __webpack_public_path__ + "static/images/upload-round.26H3m-5.svg";